"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = buildParams;
/**
 * Builds object to be used as parameters for OData request.
 * @param filters Array of strings with filter expressions.
 * @param orderBy Array of objects with fields 'property' and 'dir'.
 * @param skip
 * @param top
 * @param select
 * @param format
 * @param count
 * @param expand
 * @returns {{$format: string, $count: boolean, $skip: number, $top: number, $filter: string, $orderby: string}}
 */
function buildParams() {
	var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	var orderBy = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	var skip = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	var top = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 20;
	var select = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
	var expand = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
	var format = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 'json';
	var count = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : true;

	var d = {
		$format: format,
		$count: count
	};
	if (top > 0) {
		d.$top = top;
	}
	if (skip > 0) {
		d.$skip = skip;
	}
	if (orderBy && orderBy.length > 0) {
		d.$orderby = orderBy.map(function (v) {
			return v.property + " " + v.dir;
		}).join();
	}

	// search / filtering
	if (filters && filters.length > 0) {
		d.$filter = filters.join(" and ");
	}

	if (select && select.length > 0) {
		d.$select = select.join();
	}

	if (expand && expand.length > 0) {
		d.$expand = expand.join();
	}

	return d;
}

function convertValue(value) {
	if (typeof value === 'string') {
		return "'" + value + "'";
	}
	if (typeof value === 'number' || typeof value === 'boolean') {
		return '' + value;
	}
	if (value instanceof Date && !isNaN(value.valueOf())) {
		return value.toISOString();
	}
}

var filters = exports.filters = {
	contains: function contains(fieldName, value) {
		return "indexof(" + fieldName + "," + convertValue(value) + ") gt -1";
	},
	startsOrEndsWith: function startsOrEndsWith(fieldName, value) {
		var firstDollar = value.indexOf('$') === 0;
		var lastDollar = value.lastIndexOf('$') === value.length - 1;
		if (firstDollar && lastDollar) return fieldName + " eq " + convertValue(value.substr(1).slice(0, -1));
		if (firstDollar) return "startswith(" + fieldName + "," + convertValue(value.substr(1)) + ") eq true";
		if (lastDollar) return "endswith(" + fieldName + "," + convertValue(value.slice(0, -1)) + ") eq true";else return "indexof(" + fieldName + "," + convertValue(value) + ") gt -1";
	},
	anyContains: function anyContains(fieldName, value) {
		var propName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

		if (propName) propName = '/' + propName;
		return fieldName + "/any(x: indexof(x" + propName + "," + convertValue(value) + ") gt -1)";
	},
	anyStartsOrEndsWith: function anyStartsOrEndsWith(fieldName, value) {
		var propName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

		if (propName) propName = '/' + propName;
		return fieldName + "/any(x: " + startsOrEndsWith('x' + propName, value) + ")";
	},
	equals: function equals(fieldName, value) {
		var propName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

		if (propName) propName = '/' + propName;
		return "" + fieldName + propName + " eq " + convertValue(value);
	},
	anyEquals: function anyEquals(fieldName, value) {
		var propName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

		if (propName) propName = '/' + propName;
		return fieldName + "/any(x: x" + propName + " eq " + convertValue(value) + ")";
	},
	between: function between(fieldName, from, to) {},
	or: function or(filterConditions) {
		return "(" + filterConditions.join(' or ') + ")";
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/linksoft/utils/odata-uri.js
// module id = 159
// module chunks = 0 1